"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBool = exports.toggleStringBoolean = exports.booleanToString = void 0;
const { stringToBoolean } = require('@isoftdata/utility-string');
function booleanToString(value) {
    if (typeof value === 'string') {
        value = stringToBoolean(value);
    }
    return typeof value === 'boolean' && value ? 'True' : 'False';
}
exports.booleanToString = booleanToString;
function toggleStringBoolean(string) {
    return booleanToString(!stringToBoolean(string));
}
exports.toggleStringBoolean = toggleStringBoolean;
const isBool = (input) => typeof input === 'boolean';
exports.isBool = isBool;
//# sourceMappingURL=index.js.map